<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="状态" prop="status" v-if="dialogData.row">
        <el-switch v-model="form.status" :active-value="1" :inactive-value="0"/>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model.trim="form.name" clearable :maxlength="18" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model.trim="form.mobile" clearable :maxlength="11" show-word-limit></el-input>
      </el-form-item>
      <template v-if="!dialogData.row">
<!--        <el-form-item label="登录帐号" prop="username">-->
<!--          <el-input v-model.trim="form.username" clearable :maxlength="18" show-word-limit></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="登录密码" prop="password">
          <el-input show-password v-model.trim="form.password" clearable :maxlength="32" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input show-password v-model.trim="form.repassword" clearable :maxlength="32" show-word-limit></el-input>
        </el-form-item>
      </template>
      <el-form-item label="所属角色" prop="adm_role_id">
        <el-select v-model="form.adm_role_id">
          <el-option v-for="(item,index) in roles" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model.trim="form.remark" clearable :maxlength="128" show-word-limit></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
import {changeEmpty, inputEmpty, checkMobile, checkPwd, checkUsername} from '@utils/validate'
export default {
  name: "TableOperate",
  props: {dialogData: Object},
  data() {
    let checkRePass = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      form: {
        // username: "",
        password: "",
        repassword: "",
        name: "",
        mobile: "",
        adm_role_id: "",
        remark: "",
        status: "",
      },
      rules: {
        username: [inputEmpty("登录帐号"), checkUsername()],
        password: [inputEmpty("登录密码"), checkPwd()],
        repassword: [inputEmpty('确认密码'), {validator: checkRePass, trigger: 'blur'}],
        name: [inputEmpty("姓名")],
        mobile: [inputEmpty("手机号"),checkMobile()],
        adm_role_id: [changeEmpty("所属角色")],
      },
      roles: [],
    }
  },
  async created() {
    await this.getRoles();
    const row = this.dialogData.row;
    if (row) {
      Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
    } else {
      delete this.form.status
    }
  },
  methods: {
    confirm() {
      this.$refs["form"].validate(isOk => {
        if (isOk) {
          const row = this.dialogData.row;
          row ? this.modify(row) : this.add();
        }
      });
    },
    async add() {
      let nv = {...this.form};
      let res = await this.$Http.addAdmin(nv);
      if (res) {
        this.msgSuccess("添加成功");
        this.$emit("getData");
        this.dialogData.visible = false;
      }
    },
    async modify(row) {
      const nv = {};
      Object.keys(this.form).forEach(key => key in row && this.form[key] !== row[key] && (nv[key] = this.form[key]));
      if (!Object.keys(nv).length) return this.msgInfo("您尚未做任何修改");
      nv.admin_id = row.id;
      let res = await this.$Http.modifyAdmin(nv);
      if (res) {
        this.msgSuccess("修改成功");
        this.$emit("getData");
        this.dialogData.visible = false;
      }
    },
    async getRoles() {
      let res = await this.$Http.getRoleList();
      if (res?.data) {
        this.roles = res.data.list || [];
      }
    },
  },
}
</script>

<style scoped>

</style>
